var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77588 9.86523L8.50088 7.14023L11.2269 9.86523",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50098 13.2722V7.14022",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.551 11.289C15.143 10.8723 15.5868 10.2779 15.8182 9.59197C16.0496 8.90602 16.0564 8.1642 15.8378 7.47408C15.6192 6.78396 15.1864 6.18142 14.6022 5.75383C14.0181 5.32625 13.3129 5.09585 12.589 5.09604H11.731C11.5263 4.29712 11.143 3.55505 10.61 2.92573C10.077 2.29641 9.40809 1.79624 8.65373 1.4629C7.89937 1.12956 7.07921 0.971732 6.25502 1.00131C5.43083 1.03089 4.62409 1.2471 3.89557 1.63365C3.16705 2.02021 2.53574 2.56704 2.04918 3.23295C1.56263 3.89886 1.23353 4.66649 1.08665 5.47803C0.939775 6.28958 0.978962 7.12386 1.20126 7.91806C1.42355 8.71226 1.82316 9.44567 2.36999 10.063",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImporting);
export default __webpack_public_path__ + "static/media/importing.cbc364f18c76d0a40a15005db651187a.svg";
export { ForwardRef as ReactComponent };